import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { MqTablet, MqWide } from '~theme/media';

export const BotAvatarContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	pointer-events: none;
	user-select: none;

	${MqTablet} {
		position: fixed;
		inset: 64px 0 0;
	}
`;

export const AllContainer = styled.div`
	display: flex;
	max-width: 525px;
	flex-direction: column;
	flex-grow: 1;
	margin-right: -20px;
	gap: 16px;

	${MqWide} {
		max-width: 40%;
		margin-right: 0;
	}
`;

export const ImageContainer = styled.div`
	flex-grow: 1;
	${MqTablet} {
		position: relative;
	}
`;

export const BotAvatar = css`
	object-fit: contain;
	object-position: bottom center;
	opacity: 0.6;
	${MqTablet} {
		opacity: 1;
	}
`;
